// @flow

import url from 'url';

import ko from 'rgs-knockout';
import kv from 'rgs-knockout-validation';
import vb from 'validation-builder';
import { observableISODate } from 'observable-iso-date';
import util from 'util';

import _ from 'lodash';
import moment from 'moment';

import bytes from 'bytes';

import { serverTime } from 'observable-server-time';

import { ValidatableMixin, Validatable } from 'validatable';

import {
	JSableOmitPrivate,
	createJSableEntityListMapExtender,
	createIdentifiedEntityListMapExtender,
} from 'jsable';

import { temporaryFileInfoToFromJSExtend } from 'ko-extender-to-from-js-temporary-file-info';

import { EventEmitterMixin } from 'event-emitter';

import { IdentifiedMixin } from 'identified';

import compareUtil from 'compare-util';
import convertUtil from 'convert-util';

import type { default as Dictionaries } from './dictionaries';
import type { Observable } from 'rgs-knockout';

import Address from './models/address';

import {
	SERVICE_CHECK_KBM,
	SERVICE_APPLY_KBM,
	SERVICE_SALES_AND_CONTRACTS,
	SERVICE_CLAIMS,
	SERVICE_COMPENSATION_BEFORE_1992,
	SERVICE_CONTACTING_ANOTHER_COMPANY,
	CATEGORY_SALES_AND_CONTRACTS_IN_OFFICE,
	CATEGORY_SALES_AND_CONTRACTS_PHONE,
	CATEGORY_CLAIMS_STOA_SERVICE,
	CATEGORY_CLAIMS_STOA_REPAIR,
	CATEGORY_CLAIMS_DECISION,
	CATEGORY_CLAIMS_TERMS,
	CATEGORY_CLAIMS_COMPENSATION_REJECTION,
	CATEGORY_CLAIMS_FORFEIT_REQUIREMENT,
	CATEGORY_CLAIMS_CENTER_SERVICE,
	CATEGORY_EOSAGO_DIGITAL_SIGNATURE,
	CATEGORY_SALES_AND_CONTRACTS_AGENT,
	CATEGORY_SALES_AND_CONTRACTS_QUESTION,
	CATEGORY_CLAIMS_QUESTION,
	CATEGORY_EOSAGO_ATTACH_DK,
	SUBCATEGORY_SALES_AND_CONTRACTS_IN_OFFICE_OBTRUSION,
	SUBCATEGORY_SALES_AND_CONTRACTS_IN_OFFICE_DEAL_REJECTION,
	SUBCATEGORY_SALES_AND_CONTRACTS_IN_OFFICE_COOLING_PERIOD,
	SUBCATEGORY_SALES_AND_CONTRACTS_AGENT_OBTRUSION,
	SUBCATEGORY_SALES_AND_CONTRACTS_DIGITAL_POLICIES_VZR,
} from 'known-complaint-categories';

const REGISTRATIONS_NUMBER_DEFINITIONS = {
	'x': {
		validator: (() => {
			const cyrillic = 'АВЕКМНОРСТХУ';
			const latin = 'ABEKMHOPCTXY';
			return `[${cyrillic}${latin}${cyrillic.toLowerCase()}${latin.toLowerCase()}]`;
		})(),
		cardinality: 1,
		casing: 'upper',
	},
};
const REGISTRATIONS_NUMBER_REGEX_DEFINITIONS = {
	'0': '\\d',
	'x': '[авекмнорстухАВЕКМНОРСТУХA-Za-z0-9]',
};

const DRIVER_LICENSE_REGEX = /(\S+)\s(.+)/;

const DATE_FORMAT = 'DD.MM.YYYY';

const POLICY_START_MIN_DATE = '01.07.2003';

const filesToJSMapExtend = {
	toJSMap: files => _(files)
		.filter(f => !_.isNil(ko.unwrap(f)) && !_.isEmpty(ko.unwrap(f)))
		.map(f => f.toJS())
		.value(),
};

const DRIVER_VALIDATION_MESSAGE = 'Не является водителем по полису';

const  FILES_COUNT_LIMIT = 15;

class Captcha
	extends ValidatableMixin(JSableOmitPrivate) {
	constructor (options: FeedbackModelOptions, model: FeedbackModel) {
		super();

		this._options = options;
		this._model = model;

		this.isChecked = ko.observable(false);

		this.value = ko.map(ko.observable(), {
			mapWrite: v => {
				if (v) {
					this.value.clearError();
				}
				return v;
			},
		})
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => !this._model.Misc.isEmployeeMode()
							&& this._model.Misc.EmailCheck.isSent(),
						vb.required()
					),
				]),
			});

		this.key = ko.observable()
			.extend({ toFromJS: true });

		this.image = ko.pureComputed(() => {
			const key = this.key();
			return key
				? `/cmsapi/captcha/getNativeImage?key=${key}`
				: null;
		});
	}

	validationArray () {
		return _.filter(this, kv.utils.isValidatable);
	}
}

class EmailCheck
	extends ValidatableMixin(JSableOmitPrivate) {
	constructor (options: FeedbackModelOptions, model: FeedbackModel) {
		super();

		this._options = options;
		this._model = model;

		this.isCheckNotRequired = ko.pureComputed(() => (
			this._model.Misc.isEmployeeMode()
				|| this._model.CategoriesProvider.isCategoryAttachDK()
		));

		this.isSent = ko.observable(false);

		this.value = ko.map(ko.observable(), {
			mapWrite: v => {
				if (v) {
					this.value.clearError();
				}
				return v;
			},
		})
			.extend({
				validation: vb.all([
					vb.if(() => !this.isCheckNotRequired() && this.isSent(),
						vb.all([
							vb.required(),
						])
					),
				]),
			});
	}

	validationArray () {
		return _.filter(this, kv.utils.isValidatable);
	}
}

class KbmOsagoPolicyPerson
	extends JSableOmitPrivate {
	constructor () {
		super();

		this.LastName = ko.observable()
			.extend({ fromJS: true });

		this.FirstName = ko.observable()
			.extend({ fromJS: true });

		this.MiddleName = ko.observable()
			.extend({ fromJS: true });

		this.Birthday = ko.observable()
			.extend({ fromJS: true });
	}
}

export class KbmOsagoPolicyModel
	extends JSableOmitPrivate {
	constructor () {
		super();

		this.PolicySeries = ko.observable()
			.extend({ fromJS: true });

		this.PolicyNumber = ko.observable()
			.extend({ fromJS: true });

		this.IsUnlimitedDrivers = ko.observable()
			.extend({ fromJS: true });

		this.Drivers = ko.observableArray([])
			.extend(createJSableEntityListMapExtender(KbmOsagoPolicyPerson, []));

		this.Owner = new KbmOsagoPolicyPerson();
	}
}

class Misc
	extends Validatable {
	constructor (options: FeedbackModelOptions, model: FeedbackModel) {
		super();

		this._options = options;
		this._model = model;

		this.busy = this._options.busy;

		this.isEmployeeMode = ko.constant(this._options.context.isEmployeeMode);

		this.isKbmCheckFromLkMode = ko.pureComputed(() => {
			return compareUtil.compareStringsCaseInsensitive(this._options.context.mode,
				this._options.dictionaries.calculatorMode.kbmCheck)
				&& this._model.CategoriesProvider.isThemeKbm()
				&& !this.isEmployeeMode();
		});

		this.maxEmailOverallFileSize = ko.constant(
			bytes.parse('10mb')
		)
			.extend({
				repr: b => bytes.format(b),
			});

		this.maxFileSize = ko.constant(
			bytes.parse(this.isEmployeeMode() ? '30mb' : '10mb')
		)
			.extend({
				repr: b => bytes.format(b),
			});

		this.rgsHomeUrl = ko.pureComputed(() => {
			return url.format(url.parse(
				this._options.config.cms.pageUrls.s1.home
			));
		});

		this.kbmInfoUrl = ko.pureComputed(() => {
			return url.format(url.parse(
				this._options.config.cms.pageUrls.s1.productTypes.Osago.kbm.index
			));
		});

		this.myRgsHomeUrl = ko.pureComputed(() => {
			return url.format(url.parse(
				this._options.config.cms.pageUrls.mr.home
			));
		});

		this.isProcessingPersonalData = ko.observable(false)
			.extend({
				validation: vb.all([
					vb.equal(() =>
						true,
						'подтвердите свое согласие на обработку персональных данных'
					),
				]),
			});

		this.Captcha = new Captcha(options, model);

		this.EmailCheck = new EmailCheck(options, model);

		this.KbmOsagoPolicyModel = new KbmOsagoPolicyModel();
	}

	validationArray (options: any, ...rest: any) {
		return [
			..._.filter(this, kv.utils.isValidatable),
			...this.Captcha.validationArray(options, ...rest),
			...this.EmailCheck.validationArray(options, ...rest),
		];
	}
}

class CategoriesProvider
	extends Validatable {
	constructor (options: FeedbackModelOptions, model: FeedbackModel) {
		super();

		this._options = options;
		this._model = model;

		const { dictionaries } = this._options;

		this.defaultCategory = ko.pureComputed(() => {
			return this.get(this._options.context.category);
		});

		this.selectedTheme = ko.map(ko.observable(), {
			mapWrite: v => {
				this.selectedService(undefined);
				return v;
			},
		})
			.extend({
				validation: vb.all([
					vb.required(true, 'выберите'),
				]),
			});

		this.currentThemeCategories = ko.pureComputed(() => {
			return dictionaries.categories[this.selectedTheme()];
		});

		this.availableServices = ko.pureComputed(() => {
			const services = this.selectedTheme() && _.filter(this.currentThemeCategories(),
				item => !item.ParentID);

			if (!this._model.Misc.isEmployeeMode()) {
				_.remove(services, c => compareUtil.compareStringsCaseInsensitive(
					c.ID, SERVICE_CONTACTING_ANOTHER_COMPANY));
			}

			return !services || _.isEmpty(services) || this.isThemeDms()
				? undefined
				: _.orderBy(services, [item => item.SortOrder], ['asc']);
		});

		this.availableCategories = ko.pureComputed(() => {
			const categories = this.selectedService() && _.filter(this.currentThemeCategories(),
				item => compareUtil.compareStringsCaseInsensitive(
					item.ParentID, this.selectedService())
				);

			if (!categories || _.isEmpty(categories)) {
				return undefined;
			}

			if (this._model.isDeclarerPhysicalPerson()) {
				_.remove(categories, c => compareUtil.compareStringsCaseInsensitive(
					c.ID, CATEGORY_EOSAGO_DIGITAL_SIGNATURE));
			}

			//Категории доступные только для сотрудника
			if (!this._model.Misc.isEmployeeMode()){
				//Сервис "Продажи и сопровождение договоров"
				//Категории: "Вопрос"
				if (this._checkIsServiceSelectedById(SERVICE_SALES_AND_CONTRACTS)){
					_.remove(categories, c =>
						compareUtil.compareStringsCaseInsensitive(
							c.ID, CATEGORY_SALES_AND_CONTRACTS_QUESTION)
					);
				}

				//Сервис "Продажи и сопровождение договоров"
				//Категории: "Вопрос", "Требование об оплате неустойки"
				if (this._checkIsServiceSelectedById(SERVICE_CLAIMS)){
					_.remove(categories, c =>
						compareUtil.compareStringsCaseInsensitive(
							c.ID, CATEGORY_CLAIMS_QUESTION)
						|| compareUtil.compareStringsCaseInsensitive(
							c.ID, CATEGORY_CLAIMS_FORFEIT_REQUIREMENT)
					);
				}
			}
			
			return _.orderBy(categories, [item => item.SortOrder], ['asc']);
		});

		this.availableSubcategories = ko.pureComputed(() => {
			const subCategories = this.selectedCategory() && _.filter(this.currentThemeCategories(),
				item => compareUtil.compareStringsCaseInsensitive(
					item.ParentID, this.selectedCategory())
				);
			
			if (!subCategories || _.isEmpty(subCategories)) {
				return undefined;
			}
			
			//Подкатегории доступные только для сотрудника
			if (!this._model.Misc.isEmployeeMode()){
				// Категория "В офисе продаж" 
				// Подкатегории: "Навязывание доп. услуг", "Отказ в заключении договора", "Период охлаждения"
				if (this.isCategorySalesAndContractsInOffice()){
					_.remove(subCategories, c =>
						compareUtil.compareStringsCaseInsensitive(
							c.ID, SUBCATEGORY_SALES_AND_CONTRACTS_IN_OFFICE_OBTRUSION)
						|| compareUtil.compareStringsCaseInsensitive(
							c.ID, SUBCATEGORY_SALES_AND_CONTRACTS_IN_OFFICE_DEAL_REJECTION)
						|| compareUtil.compareStringsCaseInsensitive(
							c.ID, SUBCATEGORY_SALES_AND_CONTRACTS_IN_OFFICE_COOLING_PERIOD)
					);
				}

				// Категория "Выездной специалист (агент, финансовый консультант)" 
				// Подкатегории: "Навязывание доп. услуг"
				if (this.isCategorySalesAndContractsAgent()){
					_.remove(subCategories, c =>
						compareUtil.compareStringsCaseInsensitive(
							c.ID, SUBCATEGORY_SALES_AND_CONTRACTS_AGENT_OBTRUSION)
					);
				}
			}

			return _.orderBy(subCategories, [item => item.SortOrder], ['asc']);
		});

		this.policiesWays = ko.pureComputed(() => {
			const dmsCategories = this.selectedTheme() && _.filter(this.currentThemeCategories(),
				item => item.Type === 'Category');

			return !dmsCategories || _.isEmpty(dmsCategories)
				? []
				: _.orderBy(dmsCategories, [item => item.SortOrder], ['asc']);
		});

		this.availableDmsCategories = ko.pureComputed(() => {
			if (!this.selectedPolicyWay()) {
				return [];
			}

			const dmsCategories = this.selectedTheme() && _.filter(this.currentThemeCategories(),
				item => item.Type === 'Subcategory'
					 && item.ParentID === this.selectedPolicyWay());

			return !dmsCategories || _.isEmpty(dmsCategories)
				? []
				: _.orderBy(dmsCategories, [item => item.SortOrder], ['asc']);
		});

		this.availableProductTypes = ko.pureComputed(() => {
			const service = this.selectedService();
			const category = this.selectedCategory();
			const subCategory = this.selectedSubcategory();

			const selectedCategory = this.selectedCategoryDescription();

			if (service && !this._checkCategoryHasChildren(service)) {
				return this.selectedServiceDescription().ProductTypes;
			} else if (category && !this._checkCategoryHasChildren(category)) {
				return !selectedCategory
					? []
					: selectedCategory.ProductTypes;
			} else if (subCategory && !this._checkCategoryHasChildren(subCategory)) {
				return this.selectedSubcategoryDescription().ProductTypes;
			}

			return undefined;
		});

		this.selectedService = ko.map(ko.observable(), {
			mapRead: v => {
				if (this.isThemeKbm()) {

					const personType = this._model.PersonType();
					if (this._model.Misc.isEmployeeMode()
						|| personType === dictionaries.personTypes.juridical.id) {
						return SERVICE_APPLY_KBM;
					}
					if (personType === dictionaries.personTypes.physical.id) {
						return SERVICE_CHECK_KBM;
					}
					return undefined;
				}

				const services = this.availableServices();
				return services && services.length === 1
					? services[0].ID
					: v;
			},
			mapWrite: v => {
				this.selectedCategory(undefined);
				return v;
			},
		})
			.extend({
				validation: vb.all([
					vb.if(
						() => this.availableServices(),
						vb.cond([
							[
								() => this.isThemeKbm(),
								vb.if(() => this._model.PersonType(), vb.required()),
							],
							[
								_.stubTrue,
								vb.required(),
							],
						])
					),
				]),
			});

		this.selectedCategory = ko.map(ko.observable(), {
			mapWrite: v => {
				this.selectedSubcategory(undefined);
				return v;
			},
		})
			.extend({
				validation: vb.all([
					vb.if(() => this.availableCategories(), vb.all([
						vb.required(),
					])),
				]),
			});

		this.selectedSubcategory = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(() => this.availableSubcategories(), vb.all([
						vb.required(),
					])),
				]),
			});

		this.selectedPolicyWay = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(() => this.isThemeDms() && this._model.isDeclarerPhysicalPerson(),
						vb.all([
							vb.required(),
						])
					),
				]),
			});

		this.selectedDmsCategory = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(() => this.isThemeDms() && this._model.isDeclarerPhysicalPerson(),
						vb.all([
							vb.required(),
						])
					),
				]),
			});

		this.selectedServiceDescription = ko.pureComputed(() => {
			return this.selectedService() && this.get(this.selectedService());
		});

		this.selectedCategoryDescription = ko.pureComputed(() => {
			return this.selectedCategory() && this.get(this.selectedCategory());
		});

		this.selectedSubcategoryDescription = ko.pureComputed(() => {
			return this.selectedSubcategory() && this.get(this.selectedSubcategory());
		});

		this.isThemeKbm = ko.pureComputed(() => {
			return this.selectedTheme()
				&& this.selectedTheme() === dictionaries.themes.kbm.id;
		});

		this.isThemeOsago = ko.pureComputed(() => {
			return this.selectedTheme()
				&& this.selectedTheme() === dictionaries.themes.eOsago.id;
		});

		this.isThemeOther = ko.pureComputed(() => {
			return this.selectedTheme()
				&& this.selectedTheme() === dictionaries.themes.other.id;
		});

		this.isThemeDms = ko.pureComputed(() => {
			return this.selectedTheme()
				&& this.selectedTheme() === dictionaries.themes.health.id;
		});

		this.isThemeClaimSettlement = ko.pureComputed(() => {
			return this.selectedTheme()
				&& this.selectedTheme() === dictionaries.themes.claimSettlement.id;
		});

		this.isServiceCompensationBefore1992 = ko.pureComputed(() => {
			return this._checkIsServiceSelectedById(SERVICE_COMPENSATION_BEFORE_1992);
		});

		this.isCategoryClaimCenterService = ko.pureComputed(() => {
			return this._checkIsCategorySelectedById(CATEGORY_CLAIMS_CENTER_SERVICE);
		});

		this.isCategorySalesAndContractsPhone = ko.pureComputed(() => {
			return this._checkIsCategorySelectedById(CATEGORY_SALES_AND_CONTRACTS_PHONE);
		});

		this.isCategorySalesAndContractsInOffice = ko.pureComputed(() => {
			return this._checkIsCategorySelectedById(CATEGORY_SALES_AND_CONTRACTS_IN_OFFICE);
		});

		this.isCategorySalesAndContractsAgent = ko.pureComputed(() => {
			return this._checkIsCategorySelectedById(CATEGORY_SALES_AND_CONTRACTS_AGENT);
		});

		this.isCategoryAttachDK = ko.pureComputed(() => (
			this._checkIsCategorySelectedById(CATEGORY_EOSAGO_ATTACH_DK)
		));

		this.isSubcategoryDigitalPoliciesVzr = ko.pureComputed(() => {
			return this._checkIsSubcategorySelectedById(
				SUBCATEGORY_SALES_AND_CONTRACTS_DIGITAL_POLICIES_VZR);
		});

		this.isKbmRequestFormVisible = ko.pureComputed(() => {
			return this.isThemeKbm()
				&& (this._model.Misc.isEmployeeMode()
					|| this._model.Misc.isKbmCheckFromLkMode()
					|| this._model.isDeclarerJurdicalPerson());
		});

		this.isCategoriesSelectsVisible = ko.constant(
			this._options.context.isCategorySelectVisible
		);

		this.isServiceSelectVisible = ko.pureComputed(() => {
			return this.availableServices()
				&& this.availableServices().length > 1
				&& !this.isThemeKbm();
		});

		this.isDmsCategoriesVisible = ko.pureComputed(() => {
			return this.isThemeDms() && this._model.isDeclarerPhysicalPerson();
		});

		this.isInformationOfPaymentVisible = ko.pureComputed(() => {
			if (!this.selectedCategory()) {
				return false;
			}

			return this.isThemeClaimSettlement();
		});

		this.isInformationAboutVehicleVisible = ko.pureComputed(() => {
			/*Элементы блока должны отображаться по умолчанию при выборе категорий обращения:
			(
				Качество работы станции тех. обслуживания (СТОА) ||
				Несогласие с условиями ремонта на станции тех. обслуживания (СТОА)
			)
			или
			(product == osago || product == eOsago) &&
			(
				Несогласие с размером страхового возмещения или решением по делу ||
				Сроки урегулирования ||
				Отказ в страховом возмещении ||
				Требование об оплате неустойки
			)
			или
			(
				AccidentDamageKind == Vehicle
			)
			*/

			if (!this.selectedCategory()) {
				return false;
			}

			const selectedCategory = this.selectedCategory().toLowerCase();

			if (_.includes(_.map([
				CATEGORY_CLAIMS_STOA_SERVICE,
				CATEGORY_CLAIMS_STOA_REPAIR,
			], v => v.toLowerCase()), selectedCategory)) {
				return true;
			}

			if (!this._model.ProductType()) {
				return false;
			}

			if (this._model.AccidentDamageKind()
				=== this._options.dictionaries.accidentDamageKinds.Vehicle.ID) {
				return true;
			}

			const productType = this._model.ProductType().toLowerCase();

			return _.includes([
				"eosago",
				"osago",
			], productType)
				&& _.includes(_.map([
					CATEGORY_CLAIMS_DECISION,
					CATEGORY_CLAIMS_TERMS,
					CATEGORY_CLAIMS_COMPENSATION_REJECTION,
					CATEGORY_CLAIMS_FORFEIT_REQUIREMENT,
				], v => v.toLowerCase()), selectedCategory);
		});

		this.isHarmIsCausedVisible = ko.pureComputed(() => {
			/*Элементы блока должны отображаться по умолчанию при выборе категорий обращения:
				(product != osago && product != eOsago) &&
				(
					Несогласие с размером страхового возмещения или решением по делу ||
					Сроки урегулирования ||
					Отказ в страховом возмещении ||
					Требование об оплате неустойки
				)
			*/

			if (!this.selectedCategory() || !this._model.ProductType()) {
				return false;
			}

			const selectedCategory = this.selectedCategory().toLowerCase();
			const productType = this._model.ProductType().toLowerCase();

			return _.every([
				"eosago",
				"osago",
			], v => v !== productType)
				&& _.includes(_.map([
					CATEGORY_CLAIMS_DECISION,
					CATEGORY_CLAIMS_TERMS,
					CATEGORY_CLAIMS_COMPENSATION_REJECTION,
					CATEGORY_CLAIMS_FORFEIT_REQUIREMENT,
				], v => v.toLowerCase()), selectedCategory);
		});

		this.isProductTypesVisible = ko.pureComputed(() => {
			return this.availableProductTypes() && this.availableProductTypes().length > 1;
		});
	}

	validationArray () {
		return _.filter(this, kv.utils.isValidatable);
	}

	get (id: string) {
		return _.find(_.flatMap(this._options.dictionaries.categories, _.values),
			s => compareUtil.compareStringsCaseInsensitive(s.ID, id));
	}

	_checkCategoryHasChildren (id: string) {
		return _.some(_.flatMap(this._options.dictionaries.categories, _.values),
			s => compareUtil.compareStringsCaseInsensitive(s.ParentID, id));
	}

	_checkIsServiceSelectedById (id: string) {
		return this.selectedService()
			&& compareUtil.compareStringsCaseInsensitive(this.selectedService(), id);
	}

	_checkIsCategorySelectedById (id: string) {
		return this.selectedCategory()
			&& compareUtil.compareStringsCaseInsensitive(this.selectedCategory(), id);
	}

	_checkIsSubcategorySelectedById (id: string) {
		return this.selectedSubcategory()
			&& compareUtil.compareStringsCaseInsensitive(this.selectedSubcategory(), id);
	}
}

class Results
	extends JSableOmitPrivate {
	constructor (options: FeedbackModelOptions, model: FeedbackModel) {
		super();

		this._options = options;
		this._model = model;

		this.Success = ko.observable()
			.extend({ fromJS: true });

		this.UserCaseId = ko.observable()
			.extend({ fromJS: true });
	}
}

class Vehicle
	extends ValidatableMixin(JSableOmitPrivate) {
	constructor (options: FeedbackModelOptions, model: FeedbackModel) {
		super();

		this._options = options;
		this._model = model;

		this.regNumberMask = () => {
			return {
				mask: 'A{*}',
				placeholder: '',
				definitions: {
					'A': {
						validator: '[ 0-9a-zA-Zа-яёА-ЯЁ]',
						cardinality: 1,
					},
				},
			};
		};

		this.IsVehicleIdentificatorAbsent = ko.observable(false)
			.extend({ toFromJS: true });

		this.isVin = ko.pureComputed(() => {
			return this.VehicleType()
				=== this._options.dictionaries.vehicleIdentificatorType.vin.id;
		});

		this.isBody = ko.pureComputed(() => {
			return this.VehicleType()
				=== this._options.dictionaries.vehicleIdentificatorType.body.id;
		});

		this.isChassis = ko.pureComputed(() => {
			return this.VehicleType()
				=== this._options.dictionaries.vehicleIdentificatorType.chassis.id;
		});

		this.vehicleIdentificatorValue = ko.map(ko.observable(), {
			mapRead: v => {
				return this.IsVehicleIdentificatorAbsent()
					? undefined
					: v;
			},
		})
			.extend({
				validation: vb.all([
					vb.if(() => !this.IsVehicleIdentificatorAbsent(), vb.all([
						vb.required(),
						vb.consecutiveCharRepetitionLimit(7),
						vb.notEqual('0'),
						vb.cond([
							[
								() => this.isVin(),
								vb.all([
									vb.length(17),
									vb.commonVin(),
								]),
							],
							[
								() => this.isBody(),
								vb.vehicleBodyID(),
							],
							[
								() => this.isChassis(),
								vb.vehicleChassisID(),
							],
						]),
					])),
				]),
			});

		// Тип идентификатора ТС
		this.VehicleType = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => !this.IsVehicleIdentificatorAbsent(),
						vb.required()
					),
				]),
			});

		// VIN
		this.Vin = ko.pureComputed(() => {
			return this.isVin()
				? this.vehicleIdentificatorValue()
				: undefined;
		})
			.extend({ toFromJS: true });

		// Номер кузова
		this.BodyNumber = ko.pureComputed(() => {
			return this.isBody()
				? this.vehicleIdentificatorValue()
				: undefined;
		})
			.extend({ toFromJS: true });

		// Номер шасси
		this.ChassisNumber = ko.pureComputed(() => {
			return this.isChassis()
				? this.vehicleIdentificatorValue()
				: undefined;
		})
			.extend({ toFromJS: true });

		// ГРЗ
		this.RegNumber = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.required(),
					vb.maxLength(20),
					vb.any([
						vb.diplomaticTypeARegNumber(),
						vb.diplomaticTypeBCDRegNumber(),
						vb.transitTypeBCDRegNumber(),
						vb.tractorRegNumber(),
						vb.regNumber(),
					]),
				]),
			});

		const isCertificateCopyRequired = ko.pureComputed(() => {
			return this._model.Misc.isEmployeeMode()
				|| this._model.isDeclarerJurdicalPerson();
		});

		// Фотография свидетельства о регистрации ТС с лицевой стороны
		this.CertificateFilesObverse = ko.observableArray(
			[fileObservable(model, isCertificateCopyRequired)]
		)
			.extend({ toFromJS: true })
			.extend(filesToJSMapExtend);

		// Фотография свидетельства о регистрации ТС с обратной стороной
		this.CertificateFilesReverse = ko.observableArray(
			[fileObservable(model, isCertificateCopyRequired)]
		)
			.extend({ toFromJS: true })
			.extend(filesToJSMapExtend);
	}

	validationArray () {
		return [
			..._.filter(this, kv.utils.isValidatable),
			...this.CertificateFilesObverse(),
			...this.CertificateFilesReverse(),
		];
	}
}

class JuridicalPerson
	extends ValidatableMixin(JSableOmitPrivate) {
	constructor (options: FeedbackModelOptions, model: FeedbackModel) {
		super();

		this._options = options;
		this._model = model;

		this.isNameLikeDeclarer = ko.observable(false);

		// Название организации
		this.Name = ko.map(ko.observable(), {
			mapRead: v => {
				return this.isNameLikeDeclarer()
					? this._model.CompanyName()
					: v;
			},
		})
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.required(),
				]),
			});

		// ИНН
		this.Inn = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.required(),
					vb.ipInn(),
				]),
			});

		// Дата начала срока страхования
		this.DateIncludeInPolicy = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.required(),
					vb.momentIsValid(),
					vb.momentIsSameOrBefore(
						() => serverTime().startOf('day'),
					),
					vb.momentIsSameOrAfter(
						() => moment(POLICY_START_MIN_DATE, DATE_FORMAT),
					),
				]),
			});
	}

	validationArray () {
		return _.filter(this, kv.utils.isValidatable);
	}
}

class PhysicalPerson
	extends IdentifiedMixin(ValidatableMixin(JSableOmitPrivate)) {
	constructor (options: FeedbackModelOptions, model: FeedbackModel, mode: string) {
		super();

		this._options = options;
		this._model = model;

		this._isDriver = mode === 'driver';
		this._isOwner = mode === 'owner';
		
		// Признак, отсутствует ли предыдущее ВУ
		this.HasNoPreviousLicense = ko.observable(false)
			.extend({ toFromJS: true });

		this.makeJqInputDriverLicenseMask = () => {
			return {
				mask: 'A{*}',
				placeholder: '',
				definitions: {
					'A': {
						validator: '[ 0-9a-zA-Zа-яёА-ЯЁ]',
						cardinality: 1,
					},
				},
			};
		};

		this.fullPasportNumber = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(
						() => this._isOwner,
						vb.all([
							vb.required(),
							vb.regex(/\d{4}\s\d{6}/),
						]),
					),
				]),
			});

		// Серия паспорта
		this.PassportSeries = ko.pureComputed(() => {
			const fullPasportNumber = this.fullPasportNumber();
			if (fullPasportNumber) {
				const result = fullPasportNumber.match(/\d+/ig) || [];
				return result[0];
			}

			return undefined;
		})
			.extend({ toFromJS: true });

		// Номер паспорта
		this.PassportNumber = ko.pureComputed(() => {
			const fullPasportNumber = this.fullPasportNumber();
			if (fullPasportNumber) {
				const result = fullPasportNumber.match(/\d+/ig) || [];
				return result[1];
			}

			return undefined;
		})
			.extend({ toFromJS: true });

		this.isFioLikeDeclarer = ko.observable(false);

		// Имя
		this.FirstName = ko.map(ko.observable(), {
			mapRead: v => {
				return this.isFioLikeDeclarer()
					? this._model.FirstName()
					: v;
			},
		})
			.extend({ toFromJS: true })
			.extend({ fromJSMapLocked: true })
			.extend({
				validation: vb.all([
					vb.required(),
					vb.if(
						() => !(this._isDriver && this._model.Misc.isKbmCheckFromLkMode()),
						vb.all([
							vb.nameRussian(),
						]),
					),
					vb.if(
						() => this._isDriver && this._model.Misc.isKbmCheckFromLkMode(),
						vb.all([
							vb.nameCyrillicOrLatinWithSymbols(),
							vb.custom(
								v => {
									const drivers = this._model.Misc.KbmOsagoPolicyModel.Drivers();
									return _.isEmpty(drivers)
										|| _.some(drivers, d => compareUtil.compareStringsCaseInsensitive(d.FirstName(), v)); // eslint-disable-line max-len
								},
								DRIVER_VALIDATION_MESSAGE
							),
						])
					),
				]),
			});

		// Фамилия
		this.LastName = ko.map(ko.observable(), {
			mapRead: v => {
				return this.isFioLikeDeclarer()
					? this._model.LastName()
					: v;
			},
		})
			.extend({ toFromJS: true })
			.extend({ fromJSMapLocked: true })
			.extend({
				validation: vb.all([
					vb.required(),
					vb.if(
						() => !(this._isDriver && this._model.Misc.isKbmCheckFromLkMode()),
						vb.all([
							vb.nameRussian(),
						]),
					),
					vb.if(
						() => this._isDriver && this._model.Misc.isKbmCheckFromLkMode(),
						vb.all([
							vb.nameCyrillicOrLatinWithSymbols(),
							vb.custom(
								v => {
									const drivers = this._model.Misc.KbmOsagoPolicyModel.Drivers();
									return _.isEmpty(drivers)
										|| _.some(drivers, d => compareUtil.compareStringsCaseInsensitive(d.LastName(), v)); // eslint-disable-line max-len
								},
								DRIVER_VALIDATION_MESSAGE
							),
						])
					),
				]),
			});

		// Отчество
		this.MiddleName = ko.map(ko.observable(), {
			mapRead: v => {
				return this.isFioLikeDeclarer()
					? this._model.MiddleName()
					: v;
			},
		})
			.extend({ toFromJS: true })
			.extend({ fromJSMapLocked: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => !(this._isDriver && this._model.Misc.isKbmCheckFromLkMode()),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
					vb.if(
						() => this._isDriver && this._model.Misc.isKbmCheckFromLkMode(),
						vb.all([
							vb.nameCyrillicOrLatinWithSymbols(),
							vb.custom(
								v => {
									const drivers = this._model.Misc.KbmOsagoPolicyModel.Drivers();
									return _.isEmpty(drivers)
										|| _.some(drivers, d => compareUtil.compareStringsCaseInsensitive(d.MiddleName(), v)); // eslint-disable-line max-len
								},
								DRIVER_VALIDATION_MESSAGE
							),
						])
					),
				]),
			});

		// Дата рождения
		this.Birthday = ko.observable()
			.extend({ toFromJS: true })
			.extend({ fromJSMapLocked: true })
			.extend({
				validation: vb.all([
					vb.required(),
					vb.momentIsValid(),
					vb.momentMaxAge({
						age: 130,
						from: serverTime,
					}),
					vb.momentMinAge({
						age: 18,
						from: serverTime,
					}),
				]),
			});
			
		this.isForeignDriverLicense = ko.observable(false)
			.extend({ notify: 'always' });

		this._isTractorDriverLicense = ko.pureComputed(() => {
			return !this.isForeignDriverLicense()
				&& this.driverLicenseSeries !== undefined
				&& this.driverLicenseSeries().length === 2;
		})
			.extend({ notify: 'always' });

		this.driverLicenseSeries = ko.map(ko.observable().extend({ notify: 'always' }), {
			mapRead: v =>  v || '',
			mapWrite: convertUtil.normalizeDriverlicenseSeries,
		})
			.extend({ notify: 'always' })
			.extend(
				this._getDriverLicenseSeriesValidation(
					this._isTractorDriverLicense,
					this.isForeignDriverLicense
				)
			);
	
		this.driverLicenseNumber = ko.map(ko.observable().extend({ notify: 'always' }), {
			mapRead: v =>  v || '',
			mapWrite: convertUtil.normalizeDriverlicenseSeries,
		})
			.extend({ notify: 'always' })
			.extend(this._getDriverLicenseNumberValidation(
				this._isTractorDriverLicense,
				this.isForeignDriverLicense
				)
			);

		// ВУ
		this.License = this._observableDriverLicense(
			this.driverLicenseSeries,
			this.driverLicenseNumber,
			this._isTractorDriverLicense,
			this.isForeignDriverLicense,
			() => true
		)
			.extend({ toFromJS: true })
			.extend({ notify: 'always' })
			.extend({
				validation: vb.if(() => this._isDriver,
					vb.all([
						vb.required(),
						vb.if(() => this._isDriverLicenseEntered(
							this.driverLicenseSeries,
							this.driverLicenseNumber
						), this._getDriverLicenseValidation(
							this._isTractorDriverLicense,
							this.isForeignDriverLicense
						)),
					]),
				),
			});

		this.isForeignPreviousDriverLicense = ko.map(ko.observable(false), {
			mapRead: v => {
				return this.HasNoPreviousLicense()
					? undefined
					: v;
			},
		})
			.extend({ notify: 'always' });

		this._isTractorPreviousDriverLicense = ko.pureComputed(() => {
			return !this.isForeignPreviousDriverLicense()
				&& this.previousDriverLicenseSeries !== undefined
				&& this.previousDriverLicenseSeries().length === 2;
		})
			.extend({ notify: 'always' });

		this.previousDriverLicenseSeries = ko.map(ko.observable().extend({ notify: 'always' }), {
			mapRead: v => v || '',
			mapWrite: convertUtil.normalizeDriverlicenseSeries,
		})
			.extend({ notify: 'always' })
			.extend(this._getDriverLicenseSeriesValidation(
				this._isTractorPreviousDriverLicense,
				this.isForeignPreviousDriverLicense
			));
	
		this.previousDriverLicenseNumber = ko.map(ko.observable().extend({ notify: 'always' }), {
			mapRead: v => v || '',
			mapWrite: convertUtil.normalizeDriverlicenseSeries,
		})
			.extend({ notify: 'always' })
			.extend(this._getDriverLicenseNumberValidation(
				this._isTractorPreviousDriverLicense,
				this.isForeignPreviousDriverLicense
			));
			
		// Предыдущее ВУ
		this.PreviousLicense = this._observableDriverLicense(
			this.previousDriverLicenseSeries,
			this.previousDriverLicenseNumber,
			this._isTractorPreviousDriverLicense,
			this.isForeignPreviousDriverLicense,
			() => !this.HasNoPreviousLicense()
		)
			.extend({ notify: 'always' })
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(() => this._isDriver && !this.HasNoPreviousLicense(),
					vb.all([
						vb.required(),
						vb.if(() => this._isDriverLicenseEntered(
							this.previousDriverLicenseSeries,
							this.previousDriverLicenseNumber
						), this._getDriverLicenseValidation(
							this._isTractorPreviousDriverLicense,
							this.isForeignPreviousDriverLicense
						)),
					]),
				),
			});

		// Дата начала страхования
		this.DateIncludeInPolicy = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.required(),
					vb.momentIsValid(),
					vb.momentIsSameOrBefore(
						() => serverTime().startOf('day'),
					),
					vb.momentIsSameOrAfter(
						() => moment(POLICY_START_MIN_DATE, DATE_FORMAT),
					),
				]),
			});

		const isLicenseCopyRequired = ko.pureComputed(() => {
			return this._model.Misc.isEmployeeMode()
				&& this._isDriver;
		});

		// Фотографии ВУ с лицевой стороной
		this.LicenseFilesObverse = ko.observableArray(
			[fileObservable(model, isLicenseCopyRequired)]
		)
			.extend({ toFromJS: true })
			.extend(filesToJSMapExtend);

		// Фотографии ВУ с обратной стороной
		this.LicenseFilesReverse = ko.observableArray(
			[fileObservable(model, isLicenseCopyRequired)]
		)
			.extend({ toFromJS: true })
			.extend(filesToJSMapExtend);
		
		const isPreviousLicenseCopyRequired = ko.pureComputed(() => {
			return this._model.Misc.isEmployeeMode()
				&& this._isDriver
				&& !this.HasNoPreviousLicense();
		});

		// Фотографии ВУ с лицевой стороной
		this.PreviousLicenseFilesObverse = ko.observableArray(
			[fileObservable(model, isPreviousLicenseCopyRequired)]
		)
			.extend({ toFromJS: true })
			.extend(filesToJSMapExtend);

		// Фотографии ВУ с обратной стороной
		this.PreviousLicenseFilesReverse = ko.observableArray(
			[fileObservable(model, isPreviousLicenseCopyRequired)]
		)
			.extend({ toFromJS: true })
			.extend(filesToJSMapExtend);
	}

	validationArray () {
		return [
			..._.filter(this, kv.utils.isValidatable),
			...this.LicenseFilesObverse(),
			...this.LicenseFilesReverse(),
			...this.PreviousLicenseFilesObverse(),
			...this.PreviousLicenseFilesReverse(),
		];
	}

	_isDriverLicenseEntered = (series: Observable<string>, number: Observable<string>) => {
		return Boolean(series()) || Boolean(number());
	}

	_isDriverLicenseDuplicate = () => {
		return this._isDriverLicenseEntered(this.driverLicenseSeries, this.driverLicenseNumber)
			&& this._isDriverLicenseEntered(
				this.previousDriverLicenseSeries,
				this.previousDriverLicenseNumber
			)
			&& this.driverLicenseSeries() === this.previousDriverLicenseSeries()
			&& this.driverLicenseNumber() === this.previousDriverLicenseNumber()
			&& this.isForeignDriverLicense() === this.isForeignPreviousDriverLicense();
	}

	_getSamePreviousLicenseValidation () {
		return vb.if(
			() => this._isDriverLicenseEntered(this.driverLicenseSeries, this.driverLicenseNumber)
				&& this._isDriverLicenseEntered(
					this.previousDriverLicenseSeries,
					this.previousDriverLicenseNumber
				),
			vb.custom(
				() => !this._isDriverLicenseDuplicate(),
				() => ['исправьте, пожалуйста', 'исправьте'],
			)
		);
	}

	_getDriverLicenseValidation (
		isTractorDriverLicense: Observable<string>,
		isForeignDriverLicense: Observable<boolean>
	) {
		return vb.all([
			vb.includeSpaceBetweenSeriesAndNumber(),
			this._getSamePreviousLicenseValidation(),
			vb.if(() => !isForeignDriverLicense(),
				vb.all([
					vb.if(() => !isTractorDriverLicense(),
						vb.all([
							vb.driverLicenseRussian(),
						]),
					),
				]),
			),
		]);
	}

	_getDriverLicenseSeriesValidation (
		isTractorDriverLicense: Observable<boolean>,
		isForeignDriverLicense: Observable<boolean>
	) {
		return {
			validation: vb.if(() => this._isDriver,
				vb.all([
					vb.if(() => isForeignDriverLicense(),
						vb.all([
							vb.driverLicenseSeriesForeign(),
							vb.notOnlyZero(),
						])
					),
					vb.if(() => isTractorDriverLicense(),
						vb.all([
							vb.tractorDriverLicenseSeries(),
							vb.notOnlyZero(),
						])
					),
				]),
			)
		};
	}

	_getDriverLicenseNumberValidation (
		isTractorDriverLicense: Observable<boolean>,
		isForeignDriverLicense: Observable<boolean>
	) {
		return {
			validation: vb.if(() => this._isDriver,
				vb.all([
					vb.if(() => isForeignDriverLicense(),
						vb.all([
							vb.driverLicenseNumberForeign(),
							vb.notOnlyZero(),
						])
					),
					vb.if(() => isTractorDriverLicense(),
						vb.all([
							vb.tractorDriverLicenseNumber(),
							vb.notOnlyZero(),
						]),
					),
				]),
			),
		};
	}

	_observableDriverLicense (
		licenseSeries: Observable<string>,
		licenseNumber: Observable<string>,
		isTractorDriverLicense: Observable<boolean>,
		isForeignDriverLicense: Observable<boolean>,
		hasDriverLicense: Observable<boolean> | () => boolean
	) {
		return ko.pureComputed({
			read: () => {
				if (!hasDriverLicense()) {
					return undefined;
				}
				const series = licenseSeries() || '';
				const number = licenseNumber() || '';
		
				return series + (number ? (' ' + number) : '');
			},
			write: v => {
				const [, series, number] = DRIVER_LICENSE_REGEX.exec((v || '')) || [];

				licenseSeries(series || v);
				licenseNumber((number || '').replace(/\s/g, ''));
			}
		});
	}
}

export class KbmPolicy
	extends IdentifiedMixin(ValidatableMixin(JSableOmitPrivate)) {
	constructor (options: FeedbackModelOptions,
		model: FeedbackModel,
		isLatestPolicy: boolean = false) {
		super();

		this._options = options;
		this._model = model;

		// Признак действующего полиса
		this.IsLatestPolicy = ko.observable(isLatestPolicy)
			.extend({ toFromJS: true });

		// Серия
		this.Series = ko.observable()
			.extend({ toFromJS: true })
			.extend({ fromJSMapLocked: true });

		// Номер полиса
		this.Number = ko.observable()
			.extend({ toFromJS: true })
			.extend({ fromJSMapLocked: true })
			.extend({
				validation: vb.all([
					vb.required(),
					vb.regex(/\d{10}/),
				]),
			});

		// Регион
		this.Region = ko.pureComputed(() => {
			const region = this.regionId()
				&& this._options.dictionaries.regions.get(this.regionId());
			return region && region.name;
		})
			.extend({ toFromJS: true });
		
		this.regionId = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(
						() => this._model.Misc.isEmployeeMode()
							|| this._model.isDeclarerJurdicalPerson(),
						vb.required(),
					),
				]),
			});

		// Признак водителей без ограничений
		this.UnlimitedDrivers = ko.observable()
			.extend({ toFromJS: true })
			.extend({ fromJSMapLocked: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this._model.isDeclarerPhysicalPerson(),
						vb.required(true, 'выберите'),
					),
				]),
			});

		this.ownerType = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(
						() => this._model.Misc.isEmployeeMode()
							&& this._model.isDeclarerPhysicalPerson()
							&& this.isUnlimitedDrivers(),
						vb.required(true, 'выберите'),
					),
				]),
			});

		this.isOwnerPhysicalPerson = ko.pureComputed(() => {
			const isEmployeeMode = this._model.Misc.isEmployeeMode();
			if (this._model.isDeclarerPhysicalPerson()) {
				return !isEmployeeMode
					|| this.ownerType()
						=== this._options.dictionaries.personTypes.physical.id;
			}
			return false;
		});

		this.isOwnerJurdicalPerson = ko.pureComputed(() => {
			const isEmployeeMode = this._model.Misc.isEmployeeMode();
			return this._model.isDeclarerJurdicalPerson()
				|| (isEmployeeMode
					&& this.ownerType()
						=== this._options.dictionaries.personTypes.juridical.id);
		});

		// Признак, что собственник является ФЛ
		this.OwnerIsIndividual = ko.pureComputed(() => this.isOwnerPhysicalPerson())
			.extend({ toFromJS: true });

		const isPolicyCopyRequired = ko.pureComputed(() =>
			this._model.Misc.isEmployeeMode()
			|| this._model.isDeclarerJurdicalPerson()
		);

		// Фотографии полиса с лицевой стороны
		this.Files = ko.observableArray(
			[fileObservable(model, isPolicyCopyRequired)]
		)
			.extend({ toFromJS: true })
			.extend(filesToJSMapExtend);

		// Информация о собственнике ФЛ
		this.OwnerIndividual = new PhysicalPerson(options, model, 'owner');

		// Информация о собственнике ЮЛ
		this.OwnerLegalEntity = new JuridicalPerson(options, model);

		// Информация о водителях
		this.Drivers = ko.observableArray([
			new PhysicalPerson(this._options, this._model, 'driver'),
		])
			.extend(
				createIdentifiedEntityListMapExtender(
					PhysicalPerson,
					[options, model, 'driver']
				)
			);

		// Информация о ТС
		this.Vehicle = new Vehicle(options, model);
	}

	validationArray (options: any, ...rest: any) {
		let arr = [
			..._.filter(this, kv.utils.isValidatable),
			...this.Vehicle.validationArray(options, ...rest),
			...this.Files(),
		];

		if (this._model.isDeclarerPhysicalPerson()) {
			if (this.isLimitedDrivers()) {
				if (this._model.Misc.isEmployeeMode()) {
					arr = arr.concat([
						this.OwnerIndividual.fullPasportNumber,
					]);
				}

				arr = arr.concat([
					..._.flatMap(this.Drivers(), d => d.validationArray(options, ...rest)),
				]);
			}
			
			if (this.isUnlimitedDrivers()) {
				if (this.isOwnerPhysicalPerson()) {
					arr = arr.concat([
						...this.OwnerIndividual.validationArray(options, ...rest),
					]);
				}

				if (this.isOwnerJurdicalPerson()) {
					arr = arr.concat([
						...this.OwnerLegalEntity.validationArray(options, ...rest),
					]);
				}
			}
		}

		if (this._model.isDeclarerJurdicalPerson()) {
			arr = arr.concat([
				...this.OwnerLegalEntity.validationArray(options, ...rest),
			]);
		}

		return arr;
	}

	isUnlimitedDrivers () {
		return this.UnlimitedDrivers() === true;
	}

	isLimitedDrivers () {
		return this.UnlimitedDrivers() === false;
	}

	addDriver () {
		const driver = new PhysicalPerson(this._options, this._model, 'driver');
		this.Drivers.push(driver);
		return driver;
	}

	removeDriver (driver: PhysicalPerson) {
		if (!this.canRemoveDriver()) {
			return;
		}

		this.Drivers.remove(driver);
	}

	canAddDriver () {
		return this.Drivers().length < 5;
	}

	canRemoveDriver () {
		return this.Drivers().length > 1;
	}
}

export class KbmOsago
	extends ValidatableMixin(JSableOmitPrivate) {
	constructor (options: FeedbackModelOptions, model: FeedbackModel) {
		super();

		this._options = options;
		this._model = model;

		// Список полисов ОСАГО для КБМ
		this.Policies = ko.observableArray([
			new KbmPolicy(options, model, true),
		])
			.extend(
				createIdentifiedEntityListMapExtender(
					KbmPolicy,
					[options, model]
				)
			);
	}

	validationArray (options: any, ...rest: any) {
		return [
			..._.filter(this, kv.utils.isValidatable),
			..._.flatMap(this.Policies(), p => p.validationArray(options, ...rest)),
		];
	}

	getPolicy (id: string) {
		return _.find(this.Policies(), p => p.ID === id);
	}

	addPolicy () {
		if (!this.canAddPolicy()) {
			return _.noop();
		}

		const policy = new KbmPolicy(this._options, this._model);
		this.Policies.push(policy);
		return policy;
	}

	removePolicy (policy: KbmPolicy) {
		if (!this.canRemovePolicy()) {
			return;
		}

		this.Policies.remove(policy);
	}

	canAddPolicy () {
		return this._model.Misc.isEmployeeMode()
			&& this.Policies().length < 5;
	}

	canRemovePolicy () {
		return this.Policies().length > 1;
	}

	resetPoliciesToDefault () {
		this.Policies([
			new KbmPolicy(this._options, this._model, true),
		]);
	}
}

export class ContactInfo
	extends ValidatableMixin(JSableOmitPrivate) {
	constructor (options: FeedbackModelOptions, model: FeedbackModel) {
		super();

		this._options = options;
		this._model = model;

		// Файлы с уточнением причины обращения
		this.CommentFiles = ko.observableArray(
			[commentFileObservable(model)]
		)
			.extend({ toFromJS: true })
			.extend(filesToJSMapExtend)
			.extend({
				validation: vb.if(
					() => ko.unwrap(this._model.CategoriesProvider.isCategoryAttachDK),
					vb.custom(
						arr => {
							const filesAmount = _.filter(arr, file => file()).length;
							return filesAmount >= 1;
						},
						() => 'приложите'
					)
				)
			});

		this.commentFilesOverallSize = ko.pureComputed(() => {
			const filesArray = this.CommentFiles();
			const totalSize = _.sum(_.map(filesArray, x => {
				const file = ko.unwrap(x);
				const fileSize = file && file.Size();
				return fileSize || 0;
			}));
			return totalSize;
		});
	}

	validationArray () {
		return [
			this.CommentFiles,
			...this.CommentFiles(),
		];
	}

	addFile () {
		if (!this.canAddFile()) {
			return _.noop();
		}

		const file = commentFileObservable(this._model);
		this.CommentFiles.push(file);
		return file;
	}

	canAddFile () {
		return this.CommentFiles().length < FILES_COUNT_LIMIT;
	}
}

export type FeedbackModelOptions = {
	context: Object,
	busy: ObservableBusy,
	dictionaries: Dictionaries,
	config: Object,
};

// FIXME (TODO): Требуется полный рефакторинг модели
export class FeedbackModel
	extends ValidatableMixin(EventEmitterMixin(JSableOmitPrivate)) {
	constructor (options: FeedbackModelOptions) {
		super();

		this._options = options;
		this.dictionaries = options.dictionaries;

		this.CategoriesProvider = new CategoriesProvider(options, this);

		this.Results = new Results(options, this);

		this.Misc = new Misc(options, this);

		this.isThemeRequiresEmailSending = ko.pureComputed(() => {
			const selectedCategory = this.CategoriesProvider.selectedCategoryDescription();
			return selectedCategory && selectedCategory.IsEmailSendingRequired;
		});

		// Тип персоны инициатора
		this.PersonType = ko.observable()
			.extend({ toFromJS: true })
			.extend({ fromJSMapLocked: true })
			.extend({
				validation: vb.all([
					vb.required(true, 'выберите'),
				]),
			});

		this.isDeclarerPhysicalPerson = ko.pureComputed(() => {
			return this.PersonType()
				=== this._options.dictionaries.personTypes.physical.id;
		});

		this.isDeclarerJurdicalPerson = ko.pureComputed(() => {
			return this.PersonType()
				=== this._options.dictionaries.personTypes.juridical.id;
		});

		const isPersonFullNameEntered = ko.pureComputed(() => {
			return Boolean(this.FirstName()) && Boolean(this.LastName());
		});

		// Имя инициатора запроса (ФЛ)
		this.FirstName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.isDeclarerPhysicalPerson(),
						vb.all([
							vb.required(),
							vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
							vb.if(
								() => isPersonFullNameEntered(),
								vb.extendedSameCharsetFullName(() => this._fullName()),
							),
						]),
					),
				]),
			});

		// Фамилия инициатора запроса (ФЛ)
		this.LastName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.isDeclarerPhysicalPerson(),
						vb.all([
							vb.required(),
							vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
							vb.if(
								() => isPersonFullNameEntered(),
								vb.extendedSameCharsetFullName(() => this._fullName()),
							),
						]),
					),
				]),
			});

		// Отчество инициатора запроса (ФЛ)
		this.MiddleName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.isDeclarerPhysicalPerson(),
						vb.all([
							vb.if(
								() => !this.CategoriesProvider.isCategoryAttachDK(),
								vb.all([
									vb.required(),
								]),
							),
							vb.nameExtendedLatinOrCyrillicOrWithSymbols(),
							vb.if(
								() => isPersonFullNameEntered(),
								vb.extendedSameCharsetFullName(() => this._fullName()),
							),
						]),
					),
				]),
			});

		this._fullName = ko.pureComputed(() => {
			const [first, last, middle]
					  = [ this.FirstName(), this.LastName(), this.MiddleName() ];
			return (last || '')
				+ ' '
				+ (first || '')
				+ (middle ? ' ' + middle : '');
		});

		this.Birthday = observableISODate()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.isDeclarerPhysicalPerson()
							&& this.CategoriesProvider.isThemeDms(),
						vb.all([
							vb.required(),
							vb.momentIsValid(),
							vb.momentIsSameOrBefore(
								() => serverTime().startOf('day'),
							),
						]),
					),
				]),
			});

		// Название организации (ЮЛ)
		this.CompanyName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.isDeclarerJurdicalPerson(),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
				]),
			});

		// Контактное лицо (ЮЛ)
		this.CompanyContactPerson = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.if(
					() => this.isDeclarerJurdicalPerson()
						&& !this.CategoriesProvider.isCategoryAttachDK(),
					vb.all([
						vb.required(),
						vb.nameRussian(),
					]),
				),
			});

		this.phone = ko.observable()
			.extend({
				validation: vb.all([
					vb.required(),
					vb.phone10Digits(),
				]),
			});

		// Код города номера телефона
		this.PhoneCityCode = ko.pureComputed(() => {
			const phone = this.phone();
			if (phone) {
				const result = phone.match(/\d+/ig) || [];
				return result[0];
			}

			return undefined;
		})
			.extend({toFromJS: true});

		// Телефонный номер без кода города
		this.PhoneNumber = ko.pureComputed(() => {
			const phone = this.phone();
			if (phone) {
				const result = phone.match(/\d+/ig) || [];
				return result.splice(1).join('');
			}

			return undefined;
		})
			.extend({toFromJS: true});

		// Контактный email инициатора запроса
		this.xEmail = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.email(),
					vb.if(
						() => !this.CategoriesProvider.isCategoryAttachDK(),
						vb.all([
							vb.required(),
						]),
					),
				]),
			});

		this.OsagoPolicySeries = ko.observable()
			.extend({
				validation: vb.if(
					() => this.CategoriesProvider.isCategoryAttachDK(),
					vb.all([
						vb.required(),
					]),
				),
			});

		this.OtherPolicySeries = ko.observable();

		this.PolicySeries = ko.pureComputed(() => (
			this.CategoriesProvider.isThemeOsago()
				? this.OsagoPolicySeries()
				: this.OtherPolicySeries()
		))
			.extend({ toJS: true });

		this.PolicyNumber = ko.observable()
			.extend({ toJS: true })
			.extend({
				validation: vb.if(
					() => this.CategoriesProvider.isCategoryAttachDK(),
					vb.all([
						vb.required(),
					]),
				),
			});

		// Регион инициатора запроса
		this.regionId = ko.observable()
			.extend({
				validation: vb.if(
					() => !this.CategoriesProvider.isCategoryAttachDK(),
					vb.all([
						vb.required(),
					]),
				),
			});

		this.Region = ko.pureComputed(() => {
			const region = this.regionId()
				&& this._options.dictionaries.regions.get(this.regionId());
			return region && region.name;
		})
			.extend({ toFromJS: true });
		
		this.isPreviousNaumenTitleAvailable = ko.pureComputed(() =>
			this.CategoriesProvider.selectedCategory()
				&& !this.CategoriesProvider.isCategoryAttachDK()
				|| this.CategoriesProvider.selectedDmsCategory()
		);

		this.isCaptchaVisible = ko.pureComputed(() => {
			const isEmployeeMode = this.Misc.isEmployeeMode();

			if (isEmployeeMode) {
				return false;
			}

			const isEmailCheckSent = this.Misc.EmailCheck.isSent();
			const isEmailCheckNotRequired = this.Misc.EmailCheck.isCheckNotRequired();

			return isEmailCheckSent || isEmailCheckNotRequired;
		});

		// Номер предыдущего обращения в формате NSD (X-1234567)
		this.PreviousNaumenTitle = ko.map(ko.observable(), {
			mapRead: v => this.isPreviousNaumenTitleAvailable() ? v : null,
			mapWrite: v => v,
		})
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => !this.isPreviousNaumenTitleAbsent(),
						vb.all([
							vb.required(),
							vb.regex(/\w-\d{4,7}/),
						])
					),
				]),
			})
			.extend({ defaultValue: undefined });

		this.isPreviousNaumenTitleAbsent = ko.observable(true)
			.extend({ defaultValue: true });

		// Список выбранных категорий и подкатегорий
		this.Categories = ko.pureComputed(() => {
			const service = this.CategoriesProvider.selectedServiceDescription();
			const category = this.CategoriesProvider.selectedCategoryDescription();
			const subCategory = this.CategoriesProvider.selectedSubcategoryDescription();

			const allSelectedCategories = [];

			service && allSelectedCategories.push({
				ID: service.ID,
				Name: service.Name,
			});
			category && allSelectedCategories.push({
				ID: category.ID,
				Name: category.Name,
			});
			subCategory && allSelectedCategories.push({
				ID: subCategory.ID,
				Name: subCategory.Name,
			});

			return allSelectedCategories;
		})
			.extend({ toFromJS: true });

		// Причина обращения: вид продукта
		this.ProductType = ko.map(ko.observable(), {
			mapRead: v => {
				const availableProductTypes = this.CategoriesProvider.availableProductTypes();
				if (availableProductTypes && availableProductTypes.length === 1) {
					return availableProductTypes[0].ID;
				}

				return v;
			},
		})
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isProductTypesVisible(), vb.required()),
				]),
			})
			.extend({ defaultValue: undefined });

		// Канал поступления обращения
		this.WayAddressing = ko.map(ko.observable(), {
			mapRead: v => {
				if (this.Misc.isEmployeeMode()) {
					return v;
				}

				const defaultWayAddressing = _.find(this._options.dictionaries.wayAddressingTypes,
					w => compareUtil.compareStringsCaseInsensitive(w.ID, `site`));

				return defaultWayAddressing && defaultWayAddressing.ID;
			},
		})
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.Misc.isEmployeeMode()
							&& !this.CategoriesProvider.isCategoryAttachDK(),
						vb.required()
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Объект обращения
		this.Facility = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.Misc.isEmployeeMode()
							&& !this.CategoriesProvider.isCategoryAttachDK(),
						vb.required()
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Регион адреса офиса
		this.rgsOfficeRegionId = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isCategorySalesAndContractsInOffice(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		this.lossCenterRegionId = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isCategoryClaimCenterService(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		this.RgsOfficeRegion = ko.pureComputed(() => {
			let region;
			if (this.CategoriesProvider.isCategoryClaimCenterService()) {
				region = this.lossCenterRegionId()
					&& this._options.dictionaries.regions.get(this.lossCenterRegionId());
			} else {
				region = this.rgsOfficeRegionId()
					&& this._options.dictionaries.regions.get(this.rgsOfficeRegionId());
			}
			return region && region.id;
		})
			.extend({ toFromJS: true });

		// Город адреса офиса
		this.rgsOfficeCityId = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isCategorySalesAndContractsInOffice(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		this.lossCenterCityId = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isCategoryClaimCenterService(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		this.RgsOfficeCity = ko.pureComputed(() => {
			let city;
			if (this.CategoriesProvider.isCategoryClaimCenterService()) {
				city = this.lossCenterCityId()
					&& this._options.dictionaries.rgsOfficeCities.get(this.lossCenterCityId());
			} else {
				city = this.rgsOfficeCityId()
					&& this._options.dictionaries.rgsOfficeCities.get(this.rgsOfficeCityId());
			}
			return city && city.name;
		})
			.extend({ toFromJS: true });

		// Подразделение офиса
		this.rgsOfficeDivisionId = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isCategorySalesAndContractsInOffice(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		this.lossCenterId = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isCategoryClaimCenterService(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		this.RgsOfficeDivision = ko.pureComputed(() => {
			let division;
			if (this.CategoriesProvider.isCategoryClaimCenterService()) {
				division = this.lossCenterId()
					&& this._options.dictionaries.rgsOfficeDivisions.get(this.lossCenterId());
			} else {
				division = this.rgsOfficeDivisionId()
					&& this._options.dictionaries.rgsOfficeDivisions.get(this.rgsOfficeDivisionId()); // eslint-disable-line max-len
			}
			return division && division.address;
		})
			.extend({ toFromJS: true });

		// Название подразделения офиса
		this.RgsOfficeTitle = ko.pureComputed(() => {
			let division;
			if (this.CategoriesProvider.isCategoryClaimCenterService()) {
				division = this.lossCenterId()
					&& this._options.dictionaries.rgsOfficeDivisions.get(this.lossCenterId());
				return division && 'Центр урегулирования убытков';
			}
			division = this.rgsOfficeDivisionId()
				&& this._options.dictionaries.rgsOfficeDivisions.get(this.rgsOfficeDivisionId());
			return division && division.name;
		})
			.extend({ toFromJS: true });
		
		// Название ЦУУ
		this.LossCenter = ko.pureComputed(() => {
			const lossCenter = this.lossCenterId()
				&& this._options.dictionaries.rgsOfficeDivisions.get(this.lossCenterId());
			return this.CategoriesProvider.isCategoryClaimCenterService()
				? lossCenter && lossCenter.name
				: undefined;
		})
			.extend({ toFromJS: true });

		// Номер выплатного дела
		this.PaymentRequestNumber = ko.map(ko.observable(), {
			mapRead: v => {
				return this.isPaymentRequestNumberAbsent()
					? '0000000000'
					: v;
			},
		})
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isInformationOfPaymentVisible(),
						vb.all([
							// RGSSUP-32648: Ранее номер убытка был обязателен всегда, когда показывается инфо о ТС
							vb.if(
								() => this.CategoriesProvider.isInformationAboutVehicleVisible(),
								vb.required()
							),
							vb.regex(/^\d{10}$/),
						])
					),
				]),
			})
			.extend({ defaultValue: undefined });

		this.isPaymentRequestNumberAbsent = ko.observable(false)
			.extend({ defaultValue: false });

		// Марка автомобиля
		this.vehicleMakerId = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isInformationAboutVehicleVisible(),
						vb.required()
					),
				]),
			})
			.extend({ defaultValue: undefined });

		this.VehicleMaker = ko.pureComputed(() => {
			const maker = this.vehicleMakerId()
				&& this._options.dictionaries.vehicleMakers.get(this.vehicleMakerId());
			return maker;
		})
			.extend({ toFromJS: true });

		// Модель автомобиля
		this.vehicleModelId = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isInformationAboutVehicleVisible(),
						vb.required()
					),
				]),
			})
			.extend({ defaultValue: undefined });

		this.VehicleModel = ko.pureComputed(() => {
			const model = this.vehicleModelId()
				&& this._options.dictionaries.vehicleModels.get(this.vehicleModelId());
			return model;
		})
			.extend({ toFromJS: true });

		this.vehicleRegistrationNumberMask
			= this._makeVehicleRegistrationNumberMask('x000xx 00[0]');

		// ГРЗ
		this.VehicleRegistrationNumber = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isInformationAboutVehicleVisible(),
						vb.all([
							vb.required(),
							vb.regex(this._makeVehicleRegistrationNumberRegex('^x000xx ?000?$')),
						])),
				]),
			})
			.extend({ defaultValue: undefined });

		// Номер телефона, по которому звонили, если указан тип Другой
		this.RgsPhoneNumberInput = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() =>
						this.CategoriesProvider.isCategorySalesAndContractsPhone()
							&& this.isRgsPhoneTypeOther(),
						vb.required()),
				]),
			})
			.extend({ defaultValue: undefined });
		
		this.rgsPhoneType = ko.map(ko.observable(), {
			mapWrite: v => {
				if (v === this._options.dictionaries.rgsPhoneTypes.other.id) {
					this.RgsPhoneNumberInput(undefined);
				}
				return v;
			},
		})
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isCategorySalesAndContractsPhone(),
					vb.required()),
				]),
			})
			.extend({ defaultValue: undefined });

		this.isRgsPhoneTypeOther = ko.pureComputed(() => {
			return this.rgsPhoneType() === this._options.dictionaries.rgsPhoneTypes.other.id;
		});

		// Номер телефона РГС, по которому звонили
		this.RgsPhoneNumber = ko.pureComputed(() => {
			const phone = _.find(_.flatMap(this._options.dictionaries.rgsPhoneTypes),
				s => s.id === this.rgsPhoneType());
			return phone && phone.value;
		})
			.extend({ toFromJS: true });

		// Номер телефона, с которого звонили
		this.ClientPhoneNumber = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isCategorySalesAndContractsPhone(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Имя страхователя по компенсационным выплатам
		this.PolicyHolderFirstName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Фамилия страхователя по компенсационным выплатам
		this.PolicyHolderLastName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Отчество страхователя по компенсационным выплатам
		this.PolicyHolderMiddleName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Имя застрахованного по компенсационным выплатам
		this.InsuredPersonFirstName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Фамилия застрахованного по компенсационным выплатам
		this.InsuredPersonLastName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Отчество застрахованного по компенсационным выплатам
		this.InsuredPersonMiddleName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Имя заявителя по компенсационным выплатам
		this.DeclarantPersonFirstName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Фамилия заявителя по компенсационным выплатам
		this.DeclarantPersonLastName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Отчество заявителя по компенсационным выплатам
		this.DeclarantPersonMiddleName = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.all([
							vb.required(),
							vb.nameRussian(),
						]),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Область адреса заявителя по компенсационным выплатам
		this.DeclarantPersonProvince = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Город адреса заявителя по компенсационным выплатам
		this.DeclarantPersonCity = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Улица адреса заявителя по компенсационным выплатам
		this.DeclarantPersonStreet = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Дом адреса заявителя по компенсационным выплатам
		this.DeclarantPersonHouse = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Корпус заявителя по компенсационным выплатам
		this.DeclarantPersonBlock = ko.observable()
			.extend({ toFromJS: true })
			.extend({ defaultValue: undefined });

		// Квартира заявителя по компенсационным выплатам
		this.DeclarantPersonApartment = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Дата отправки документов в расчетный центр
		this.DocumentSendDate = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.all([
							vb.required(),
							vb.momentIsValid(),
							vb.momentIsSameOrBefore(
								() => serverTime().endOf('day'),
							),
						])
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Номер заказного письма
		this.RegisteredMailNumber = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isServiceCompensationBefore1992(),
						vb.required(),
					),
				]),
			})
			.extend({ defaultValue: undefined });

		// Описание причины обращения
		this.ComplaintText = ko.observable()
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.if(
						() => !this.CategoriesProvider.isCategoryAttachDK(),
						vb.required(),
					),
					vb.maxLength(4000),
				]),
			});

		this.reponseByType = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(
						() => this.Misc.isEmployeeMode()
							&& !this.CategoriesProvider.isCategoryAttachDK(),
						vb.all([
							vb.required(),
						])
					),
				]),
			});
		
		this.isResponseByPost = ko.pureComputed(() => {
			return this.reponseByType()
				=== this._options.dictionaries.responseByType.post.id;
		});

		// Тип получения результата рассмотрения обращения (электронная почта или обычное письмо)
		this.ResponseBy = ko.pureComputed(() => {
			const responseBy = [];

			if (!this.Misc.isEmployeeMode()) {
				responseBy.push(this._options.dictionaries.responseByType.email.id);
			} else {
				const responseType = this.reponseByType();
				if (responseType) {
					responseBy.push(responseType);
				}
			}
			
			return responseBy;
		})
			.extend({ toFromJS: true });

		// Адрес электронной почты для отправки результата рассмотрения
		this.ResponseEmail = ko.pureComputed(() => {
			return this.xEmail();
		})
			.extend({ toFromJS: true });

		this._isResponseAddressNeeded = ko.pureComputed(() => (
			this.Misc.isEmployeeMode()
				&& this.isResponseByPost()
				&& !this.CategoriesProvider.isCategoryAttachDK()
		));

		this.ResponseAddress = new Address(options, this._isResponseAddressNeeded);

		// Дополнительные сведения от заявителя
		this.ContactInfo = new ContactInfo(options, this);

		// Информация по типу КМБ по ОСАГО
		this.KbmOsago = new KbmOsago(options, this);

		// Тип продукта при выборе причинения ущерба
		this.AccidentDamageKind = ko.observable()
			.extend({
				validation: vb.all([
					vb.if(() => this.CategoriesProvider.isHarmIsCausedVisible(),
						vb.required(),
					),
				]),
			})
			.extend({ toFromJS: true })
			.extend({ defaultValue: undefined });

		this.FromDmsLk = ko.observable(false);
	}

	resetCategorySpecifiedFieldsToDefault () {
		this._resetObservablesToDefault();
		this.KbmOsago.resetPoliciesToDefault();
	}

	_resetObservablesToDefault () {
		const observablesWithDefaultValue = _.filter(this,
			p => ko.isObservable(p) && _.has(p, 'defaultValue'));

		_.forEach(observablesWithDefaultValue, obs => obs(obs.defaultValue()));
	}

	_makeVehicleRegistrationNumberMask (mask: string) {
		return {
			mask: mask.replace(/0/g, '9'),
			greedy: false,
			definitions: REGISTRATIONS_NUMBER_DEFINITIONS,
		};
	}

	_makeVehicleRegistrationNumberRegex (template: string) {
		const src = _.reduce(
			REGISTRATIONS_NUMBER_REGEX_DEFINITIONS,
			(tmpl, value, key) => tmpl.replace(new RegExp(key, 'g'), value),
			template
		);
		return new RegExp(src, 'i');
	}

	validationArray (options: any, ...rest: any) {
		let arr = [
			..._.filter(this, kv.utils.isValidatable),
			...this.CategoriesProvider.validationArray(options, ...rest),
			...this.ContactInfo.validationArray(options, ...rest),
			...this.Misc.validationArray(options, ...rest),
			...this.ResponseAddress.validationArray(options, ...rest),
		];

		if (this.CategoriesProvider.isThemeKbm()){
			arr = arr.concat([
				...this.KbmOsago.validationArray(options, ...rest),
			]);
		}

		return arr;
	}

	toJS () {
		const js = super.toJS();

		if (!this._isResponseAddressNeeded()) {
			js.ResponseAddress.Kladr = null;
			js.ResponseAddress.ZipCode = null;
			js.ResponseAddress.Apartement = null;
			js.ResponseAddress.HasStreets = null;

			js.ResponseAddress.Settlement = {};
			js.ResponseAddress.Street = {};
			js.ResponseAddress.House = {};
		}

		return _.omit(js, 'Results');
	}
}

function fileObservable (model: FeedbackModel, isRequired: any) {
	return ko.observable()
		.extend(temporaryFileInfoToFromJSExtend)
		.extend({
			validation: vb.all([
				vb.if(
					() => ko.unwrap(isRequired),
					vb.required(true, 'приложите')
				),
				vb.fileMaxSize(() => model.Misc.maxFileSize()),
				vb.fileUploadFulfilled(),
			]),
		});
}

function commentFileObservable (model: FeedbackModel) {
	return ko.observable()
		.extend(temporaryFileInfoToFromJSExtend)
		.extend({
			validation: vb.all([
				vb.if(
					() => model.isThemeRequiresEmailSending() && !model.Misc.isEmployeeMode(),
					vb.custom(
						() => {
							const contactInfo = model.ContactInfo;

							const maxSizeValue = model.Misc.maxEmailOverallFileSize();
							const overallFilesSize = contactInfo.commentFilesOverallSize();

							return !overallFilesSize
								|| overallFilesSize <= maxSizeValue;
						},
						() => {
							const maxSizeRepr = model.Misc.maxEmailOverallFileSize.repr();
							return util.format('Общий размер файлов - не более %s', maxSizeRepr);
						},
					),
					vb.fileMaxSize(() => model.Misc.maxFileSize()),
				),
				vb.fileUploadFulfilled(),
			]),
		});
}